(() => {
  const STORAGE_KEY = 'engagement-rings:wishlist';
  const buttonSelector = [
    '[data-wishlist-button]',
    '.product-card__wishlist',
    '.product-card__wishlist-button',
    '.product-carousel__wishlist',
    '.ha-pc-card-wishlist',
    '.guess-you-like__heart',
    '.carousel__wishlist'
  ].join(',');

  const read = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return new Map((Array.isArray(saved) ? saved : []).map(item => {
        const record = item && typeof item === 'object' ? item : { id: item };
        return [String(record.id), record];
      }).filter(([id]) => id && id !== 'undefined'));
    } catch {
      return new Map();
    }
  };

  const write = saved => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...saved.values()]));
      document.dispatchEvent(new CustomEvent('popular-ring-wishlist:change'));
      window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: saved.size } }));
      return true;
    } catch {
      return false;
    }
  };

  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const escapeHtml = value => clean(value).replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[character]));

  const getCard = button => button.closest('[data-product-id], product-card, .product-card, .per-card, [data-product-handle]');

  const getRecord = button => {
    const card = getCard(button);
    if (!card) return null;
    const dataset = { ...(card?.dataset || {}), ...(button.dataset || {}) };
    const title = dataset.productTitle || card.querySelector('.product-card__title, .product-title--card, .per-title, [data-product-title]')?.textContent;
    const link = card.querySelector('a[href*="/products/"]') || card.querySelector('a[href]');
    const image = card.querySelector('img:not(.wishlist-icon), .product-card__image img, .per-image');
    const price = dataset.productPrice || card.querySelector('.product-card__price-current, .per-price, .price-list')?.textContent;
    const variantId = dataset.productVariantId || dataset.variantId || card.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const id = dataset.productId || dataset.id || dataset.productHandle;
    if (!id) return null;
    let diamond;
    try { diamond = JSON.parse(dataset.productDiamond || 'null') || undefined; } catch {}
    return {
      diamond,
      id: String(id),
      handle: dataset.productHandle || '',
      title: clean(title),
      url: dataset.productUrl || link?.getAttribute('href') || '#',
      image: dataset.productImage || image?.currentSrc || image?.getAttribute('src') || '',
      price: clean(price),
      category: dataset.productCategory || dataset.category || '',
      variantId: variantId || ''
    };
  };

  const setButtonState = (button, active) => {
    button.classList.toggle('is-active', active);
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', String(active));
    const name = button.closest('[data-product-title]')?.dataset.productTitle || getCard(button)?.querySelector('.product-card__title, .product-title--card, .per-title')?.textContent || 'product';
    button.setAttribute('aria-label', `${active ? 'Remove' : 'Add'} ${clean(name)} ${active ? 'from' : 'to'} wishlist`);
    button.setAttribute('title', active ? 'Remove from wishlist' : 'Add to wishlist');
  };

  const refresh = scope => {
    const saved = read();
    (scope || document).querySelectorAll(buttonSelector).forEach(button => {
      const id = button.dataset.productId || getCard(button)?.dataset.productId || getCard(button)?.dataset.productHandle;
      if (id) setButtonState(button, saved.has(String(id)));
    });
    document.querySelectorAll('[data-wishlist-count-badge]').forEach(badge => {
      badge.textContent = saved.size;
      badge.hidden = saved.size === 0;
    });
  };

  document.addEventListener('click', event => {
    const button = event.target.closest(buttonSelector);
    if (!button || button.matches('[data-popular-wishlist]')) return;
    const record = getRecord(button);
    if (!record) return;
    event.preventDefault();
    event.stopPropagation();
    const saved = read();
    const id = String(record.id);
    if (saved.has(id)) saved.delete(id);
    else saved.set(id, record);
    if (write(saved)) setButtonState(button, saved.has(id));
  }, true);

  document.addEventListener('DOMContentLoaded', () => refresh());
  document.addEventListener('popular-ring-wishlist:change', () => refresh());
  window.addEventListener('storage', () => refresh());
  new MutationObserver(mutations => {
    mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) refresh(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.SinceLoveWishlist = Object.freeze({
    key: STORAGE_KEY,
    get: () => [...read().values()],
    remove: id => { const saved = read(); saved.delete(String(id)); return write(saved); },
    clear: () => write(new Map()),
    escapeHtml
  });
})();
